import {
  FORTA_BLUE,
  FORTA_GRAY2,
  FORTA_GRAY3,
  FORTA_WHITE,
} from '../../../../../../../utils/colors';

export const TECHNIQUE_FIELD_ROOT_SX = {
  height: '100%',
  border: `1px solid ${FORTA_BLUE.light2}`,
  borderRadius: '8px',
  backgroundColor: FORTA_WHITE,
  p: 1.5,
  boxShadow: '0px 2px 6px rgba(18, 78, 120, 0.16)',
};

export const GOAL_INCORPORATED_FIELDS_SX = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  gap: 2,
  mb: 3,
};

export const GOAL_TIMING_FIELD_ROOT_SX = {
  border: `1px solid ${FORTA_BLUE.light2}`,
  borderRadius: '8px',
  backgroundColor: FORTA_WHITE,
  p: { xs: 1, sm: 1.5 },
  boxShadow: '0px 2px 6px rgba(18, 78, 120, 0.16)',
};

export const GOAL_TIMING_INPUTS_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr) 78px',
    sm: 'minmax(0, 1fr) auto minmax(0, 1fr) auto',
  },
  gap: 1,
  alignItems: 'flex-start',
};

export const GOAL_TIMING_NOW_BUTTON_SX = {
  height: { xs: 42, sm: 40 },
  minWidth: { xs: 64, sm: 78 },
  borderRadius: '8px',
  backgroundColor: FORTA_BLUE.light2,
  color: FORTA_WHITE,
  fontWeight: 700,
  px: { xs: 1, sm: 2 },
  '&:hover': {
    backgroundColor: FORTA_BLUE.light1,
  },
  '&:disabled': {
    backgroundColor: FORTA_GRAY3,
    color: FORTA_WHITE,
  },
};

export const GOAL_TIMING_ADD_BUTTON_SX = {
  mt: 1.5,
  height: { xs: 42, sm: 40 },
  minWidth: { xs: 164, sm: 0 },
  borderRadius: '8px',
  backgroundColor: FORTA_BLUE.primary,
  color: FORTA_WHITE,
  fontWeight: 700,
  px: { xs: 2, sm: 2 },
  '&:hover': {
    backgroundColor: FORTA_BLUE.light1,
  },
  '&:disabled': {
    backgroundColor: FORTA_GRAY3,
    color: FORTA_WHITE,
  },
};

export const GOAL_TIMING_SELECTED_LIST_SX = {
  display: 'flex',
  flexDirection: 'column',
  mt: 1.5,
};

export const GOAL_TIMING_SELECTED_ITEM_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  backgroundColor: FORTA_GRAY2,
  borderTop: `1px solid ${FORTA_BLUE.light2}`,
  px: 1,
  py: 1,
};

export const TECHNIQUE_SELECTED_LIST_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  mt: 1.5,
};

export const TECHNIQUE_SELECTED_ITEM_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  border: `1px solid ${FORTA_BLUE.light2}`,
  borderRadius: '8px',
  backgroundColor: FORTA_WHITE,
  px: 1.5,
  py: 1,
};

export const TECHNIQUE_DELETE_BUTTON_SX = {
  backgroundColor: 'transparent',
  '&:disabled': {
    opacity: 0.5,
  },
};
